/**
 * Gmail-like e-mails input type
 */
class MultiEmailsInput {
    /**
     * Constructor
     * @param {*} selector
     * @param {*} options
     */
    constructor(selector, options) {
        if (!options) options = {}

        this.options = options

        selector.classList.add('lib-emails-input-container')
        this.emailsContainer = document.createElement('span')
        this.emailsContainer.classList.add('emails-container')

        this.inputBox = this.createTextBox()

        selector.appendChild(this.emailsContainer)
        selector.addEventListener('click', () => {
            this.inputBox.focus()

            if (options.onFocus) {
                options.onFocus()
            }
        })
        selector.appendChild(this.inputBox)

        if (options.onChange) {
            this.onChange = options.onChange
        }

        this.listOfValidEmails = []
    }

    isValidEmail(email, limitEmailsToDomain) {
        const expression = new RegExp(
            '^([a-zA-Z0-9_\\-\\.]+)@' +
            (limitEmailsToDomain || '([a-zA-Z0-9_\\-\\.]+)') +
            '\\.([a-zA-Z]{2,5})$'
        )

        return expression.test(email)
    }

    /**
     * Update placeholders, check max values & trigger change
     */
    checkAndFixInputPlaceHolder(triggerNoChange = false) {
        const hasEmails = this.listOfValidEmails.length > 0

        if (hasEmails) {
            this.inputBox.placeholder = this.options.placeholder || 'add more people...'
        } else {
            this.inputBox.placeholder = this.options.placeholder || 'add people...'
        }

        if (this.options.max && this.listOfValidEmails.length >= this.options.max) {
            this.inputBox.classList.add('d-none')
        } else {
            this.inputBox.classList.remove('d-none')
        }

        //this.inputBox.setAttribute('size', 999)

        if (this.onChange && !triggerNoChange) {
            this.onChange(this.getEmailsList())
        }
    }

    /**
     * Generates an email block
     *
     * @param {string} email - email to be added to list
     */
    addEmailToList(email, triggerNoChange = false) {
        email = email.trim()

        if (!email) return

        // Check if email is duplicate
        if (this.listOfValidEmails.indexOf(email) > -1) {
            return
        }

        const emailBlock = document.createElement('span')

        emailBlock.innerText = email
        emailBlock.setAttribute('data-value', email)
        emailBlock.classList.add('email-block')

        if (!this.isValidEmail(email, this.options.limitEmailsToDomain)) {
            emailBlock.classList.add('invalid-email')
            emailBlock.classList.add(this.options.invalidEmailClass) // optional
        } else {
            this.listOfValidEmails.push(email)
            emailBlock.classList.add(this.options.validEmailClass) // optional
        }

        // stop propagation to enable selection email block
        emailBlock.addEventListener('click', function (e) {
            e.stopPropagation()
        })

        const removeBtn = document.createElement('span')
        removeBtn.innerHTML = '&times;'
        removeBtn.classList.add('remove-button')

        removeBtn.addEventListener('click', () => {
            if (removeBtn.parentElement.className.indexOf(' invalid-email') === -1) {
                this.listOfValidEmails.splice(
                    parseInt(removeBtn.parentElement.getAttribute('data-value')),
                    1
                )
            }

            removeBtn.parentElement.parentNode.removeChild(removeBtn.parentElement)
            this.checkAndFixInputPlaceHolder()
        })

        emailBlock.appendChild(removeBtn)

        this.emailsContainer.appendChild(emailBlock)
        this.checkAndFixInputPlaceHolder(triggerNoChange)
    }

    /**
     * creates input box and add event listening
     */
    createTextBox() {
        const input = document.createElement('input');
        input.classList.add('email-input')
        input.placeholder = this.options.placeholder || 'add people...'

        input.setAttribute('type', 'email')
        //input.setAttribute('size', 999)

        // create email block in case user press 'Enter' or comma
        input.addEventListener('keypress', (e) => {
            if (e.key === ',' || e.key === 'Enter') {
                if (e.target.value !== '') {
                    this.addEmailToList(e.target.value)
                }

                e.preventDefault()
                e.target.value = ''
            }
        })

        // create email block in case user lose focus
        input.addEventListener('blur', (e) => {
            if (e.target.value !== '') {
                this.addEmailToList(e.target.value)
                e.target.value = ''
            }
        })

        // listen to the paste event to split and show emails blocks
        input.addEventListener('paste', (e) => {
            setTimeout(() => {
                const pastedContent = e.target.value.split(',')
                pastedContent.forEach((element) => {
                    this.addEmailToList(element)
                    e.target.value = ''
                })
            }, 50)
        })

        return input
    }

    /**
     * Set values for emails
     * @param {Array} values
     */
    setValues(values = []) {
        values.forEach(emailValue => this.addEmailToList(emailValue, true))
    }

    /**
     * Return the valid array of emails
     */
    getEmailsList() {
        return this.listOfValidEmails
    }
}

export default MultiEmailsInput
